import { put, takeLatest, call } from "redux-saga/effects";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import * as apis from "../../network/apis/applicantTabExportSheet";
import * as types from "./types";

function* getExportApplicantsListSaga(action) {
  try {
    const response = yield call(
      apis.exportAdminEventRequests,
      action.payload.params,
      { handlerEnabled: false },
    );
    yield put(actions.getExportApplicantsResponse(response.data));
    yield showSuccessMsg("File Downloaded Successfully!", true);
  } catch (error) {
    // When offline / network failure there is no `response`; the axios interceptor
    // already shows `shared.noInternetConnection` — avoid overwriting it here.
    if (error?.response) {
      showErrorMsg(
        error.response?.data?.message || "Error while Exporting File"
      );
    }
  }
}

export default function* ApplicantTabExportSheetSaga() {
  yield takeLatest(
    types.GET_APPLICANTS_EXPORT_REQUEST,
    getExportApplicantsListSaga
  );
}
